// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bz-2";
export var aiChatCartContainerExit = "_bz-4";
export var aiChatContainerLarge = "_bz-0";
export var aiChatContainerSmall = "_bz-1";
export var aiChatIcon = "_bz-6";
export var slideInFromRight = "_bz-3";
export var slideOutToRight = "_bz-5";